export default __webpack_public_path__ + "static/media/c7.716e46e7.jpg";